import { useTranslation } from 'react-i18next';
import {
    IFilterOption,
    FilterTypes,
    useAppSelector,
    IOption,
} from '../../../../base';
import { JobStatus } from '../../../../common';
import { userSelectors } from '../../../../actions';

export const useTableFilters = (): IFilterOption[] => {
    const { t } = useTranslation();
    const baseUsersOptions = useAppSelector(userSelectors.getUsersOptions);

    const jobsStatusesOptions = (): Array<IOption> => [
        {
            key: JobStatus.Draft,
            label: t(`statuses.${JobStatus.Draft}`),
            value: JobStatus.Draft,
        },
        {
            key: JobStatus.Published,
            label: t(`statuses.${JobStatus.Published}`),
            value: JobStatus.Published,
        },
        {
            key: JobStatus.Closed,
            label: t(`statuses.${JobStatus.Closed}`),
            value: JobStatus.Closed,
        },
        {
            key: JobStatus.Suspended,
            label: t(`statuses.${JobStatus.Suspended}`),
            value: JobStatus.Suspended,
        },
        {
            key: JobStatus.Canceled,
            label: t(`statuses.${JobStatus.Canceled}`),
            value: JobStatus.Canceled,
        },
    ];

    return [
        {
            id: 'published_date',
            label: t('jobsTable.publishedDate'),
            type: FilterTypes.datepicker_range,
        },
        {
            id: 'status',
            label: t('jobsTable.status'),
            type: FilterTypes.options,
            optionValues: jobsStatusesOptions(),
        },
        {
            id: 'recruiter',
            label: t('jobsTable.recruiter'),
            type: FilterTypes.options,
            optionValues: baseUsersOptions,
        },
        {
            id: 'recruiting_manager',
            label: t('jobsTable.recruitingManager'),
            type: FilterTypes.options,
            optionValues: baseUsersOptions,
        },
        {
            id: 'tags',
            label: t('jobsTable.tags'),
            type: FilterTypes.tags,
        },
    ];
};
